import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import isArray from "lodash/isArray";
// mui
import Box from "@mui/material/Box";
import isString from "lodash/isString";
import { styled } from "@material-ui/styles";

import { StoreContext } from "../../../../../../../../../../store/StoreProvider";
import Act from "../../../../../../../../../../store/actions";
// component
import SocietyNetwork from "../../../../../../../main/displayArea/drawSnaLxt/SocietyNetwork";
import { isTrue, uuidv4 } from "../../../../../../../../../../common/utils";
import { placeNodeConfig } from "../../../../../../../main/displayArea/drawSnaLxt/networkConfig";
import {
  onClickLink,
  onClickNode,
  onMouseOutNode,
  onMouseOverNode,
} from "../../../../../../../main/displayArea/helper";
import { setInfoMessage } from "../../../../../../../../../../reduxStore/commonSlice";
import useRefDimensions from "../../../../../../../../../../common/hooks/useRefDimensions";
// eslint-disable-next-line import/no-cycle
import {
  SNA_DISPLAY_DIV_ID,
  SNA_WRAPPER_DIV_ID,
} from "../../../../../../../../config";

const StyledBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "calc(100vh - 300px)",
  borderRadius: "8px",
  boxShadow: "0 15px 30px 0 rgba(180, 189, 207, 0.3)",
  backgroundColor: "#ffff",
  border: "1px #E7E7E7 solid",
}));
const AIDisplayArea = () => {
  const reduxDispatch = useDispatch();
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { tableData: datas } = sna.AI;
  const { open } = sna.sidebar;
  const { adjust } = sna;
  const defaultWidth = open ? window.innerWidth - 458 : window.innerWidth - 218;
  const [networkDataFiltered, setNetworkDataFiltered] = useState([]);
  const [snaColors, setSnaColors] = useState(adjust.nodeColors.initial);
  const [snaGroups, setSnaGroups] = useState([]);
  const [focusNodes, setFocusNodes] = useState([]); // 有聚焦的 nodes

  // 建立 ref 傳遞給 SocietyNetwork component 以取得 SNA 繪圖區, 便於匯出圖片
  const myRef = React.createRef();
  // todo: 建立 ref 抓取繪圖區外的 box 邊界
  const myRef2 = React.createRef();
  // 一開始 myRef.current 為 null, 所以會先取 width 當snaWidth預設值
  const [snaWidth, setSnaWidth] = useState(
    myRef?.current?.offsetWidth || defaultWidth
  );
  // 一開始 myRef.current 為 null, 所以會先取 height 當snaHeight預設值
  const [snaHeight, setSnaHeight] = useState(
    myRef?.current?.offsetHeight || window.innerHeight - 300
  );
  const myRef2WidthHeight = useRefDimensions(myRef2);

  const updateWidthAndHeight = (ele) => () => {
    if (document.fullscreenElement) {
      // it's fullscreen!
      // 變更 sna svg 的長寬
      if (ele.innerWidth) {
        setSnaWidth(ele.innerWidth);
      }
      if (ele.innerHeight) {
        setSnaHeight(ele.innerHeight);
      }
    } else {
      // not fullscreen!
      setSnaWidth(defaultWidth);
      setSnaHeight(window.innerHeight - 300);
    }
  };
  // for fullscreen
  useEffect(() => {
    window.addEventListener("resize", updateWidthAndHeight(window));
    return () =>
      window.removeEventListener("resize", updateWidthAndHeight(window));
  });

  useEffect(() => {
    setSnaWidth(defaultWidth);
  }, [open, window.innerWidth]);

  useEffect(() => {
    setSnaHeight(window.innerHeight - 300);
  }, [window.innerHeight]);

  // 偵測 sna wrapper 的 width,height 變動,當作 拖曳視窗的邊界
  useEffect(() => {
    dispatch({
      type: Act.SNA_DISPLAY_MEMO_WIDTH,
      payload: myRef2WidthHeight.width,
    });
    dispatch({
      type: Act.SNA_DISPLAY_MEMO_HEIGHT,
      payload: myRef2WidthHeight.height,
    });
  }, [myRef2WidthHeight.width, myRef2WidthHeight.height]);

  useEffect(() => {
    const relationToNodeInAI = (relData = []) => {
      const nodes = [];
      relData.forEach((dt, idx) => {
        const eventId = `evt-${uuidv4()}`;
        const { srcId, srcLabel, dstId, dstLabel } = dt;
        nodes.push({
          event: eventId,
          id: srcId,
          label: srcLabel,
        });
        nodes.push({
          event: eventId,
          id: dstId,
          label: dstLabel,
        });
      });
      return nodes;
    };
    const getNodes = relationToNodeInAI(datas);
    // setNetworkData(getNodes);
    setNetworkDataFiltered(getNodes);
    dispatch({
      type: Act.SNA_DIARY_INFO_EVENT_LIST,
      payload: getNodes,
    });
  }, []);

  useEffect(() => {
    // 當 sna 的資料變動時,要清空 focusNodes
    setFocusNodes([]);
  }, [networkDataFiltered]);

  useEffect(() => {
    // local 的 focusNodes 狀態變更時,更新狀態到 store
    if (isArray(focusNodes)) {
      dispatch({
        type: Act.SNA_DISPLAY_FOCUS_NODES,
        payload: focusNodes,
      });
    }
  }, [focusNodes]);
  return (
    <StyledBox ref={myRef2} id={SNA_WRAPPER_DIV_ID}>
      <Box textAlign="center">
        {/* @ts-ignore */}
        <SocietyNetwork
          // @ts-ignore
          // maxLinks={Number.parseInt(linkCount.initial, 10)}
          // maxNodes={Number.parseInt(nodeCount.initial, 10)}
          // limitTotalNodesCount={Number.parseInt(
          //   limitTotalNodesCount.initial,
          //   10
          // )}
          data={networkDataFiltered}
          // @ts-ignore
          group={snaGroups.map((s) => s.label)}
          addNodeCount={isTrue(adjust?.nodeShowNodeCount?.initial)}
          placeNodeMode={adjust?.nodePlaceMode?.initial}
          placeNodeConfig={placeNodeConfig}
          statisticDispersion={Number.parseInt(
            adjust?.nodeDispersion?.initial,
            10
          )}
          colors={snaColors}
          legendShowNodDataGroup={isTrue(
            adjust?.legendShowNodDataGroup?.initial
          )}
          // nodeCountMeetAuth={nodeCountMeetAuth?.initial}
          // nodeCountMeetAuthNew={nodeCountMeetAuthNew?.initial}
          // @ts-ignore
          onGroupNetworkDataReady={(data) =>
            dispatch({
              type: Act.SNA_DISPLAY_DRAW_NETWORK_DATA,
              payload: { ...data },
            })
          }
          myRef={myRef}
          // sidebarOpen={sidebar.open}
          snaWidth={snaWidth}
          snaHeight={snaHeight}
          snaDivId={SNA_DISPLAY_DIV_ID}
          onClickNode={onClickNode(focusNodes, setFocusNodes)}
          onMouseOverNode={onMouseOverNode(state, dispatch)}
          onMouseOutNode={onMouseOutNode(state, dispatch)}
          onClickLink={onClickLink(state, dispatch)}
          // @ts-ignore
          alertCallback={(msg) => {
            reduxDispatch(
              setInfoMessage({
                open: true,
                content: isString(msg) ? msg : JSON.stringify(msg),
                duration: 6000,
              })
            );
          }}
        />
      </Box>
    </StyledBox>
  );
};
export default AIDisplayArea;
